export const Products = {
  CheckoutProduct: 'CheckoutProduct',
  PeopleCountingProduct: 'PeopleCountingProduct',
  PeopleCountingGenderAgeProduct: 'PeopleCountingGenderAgeProduct',
  PersonnelTrackingProduct: 'PersonnelTrackingProduct',
  InstoreAnalyticsProduct: 'InstoreAnalyticsProduct'
};
